import { HiArrowLeft } from 'react-icons/hi'
import { MdQrCode } from 'react-icons/md'
import { useSelector } from 'react-redux'

import { CloseButton, HStack, IconButton, Spacer, Text } from '@chakra-ui/react'

import { selectEditMode } from '@/redux/ui/uiSlice'

interface EditCheckPointHeaderIProps {
  onClose: () => void
}

export const EditCheckPointHeader = ({
  onClose,
}: EditCheckPointHeaderIProps) => {
  const isEditMode = useSelector(selectEditMode)
  return (
    <HStack align='center' direction='row' padding='30px' paddingBottom='20px'>
      {!isEditMode && (
        <IconButton
          aria-label='close edit checkpoint'
          borderRadius='2xl'
          h='30px'
          icon={<HiArrowLeft size={24} />}
          minWidth='30px'
          onClick={onClose}
          variant='ghost'
          w='30px'
        />
      )}
      <MdQrCode color='#44546F' size={32} />

      <Text color='#1F2023' fontSize='24px' fontWeight={700} lineHeight='30px'>
        {isEditMode ? 'Edit Checkpoint' : 'Checkpoint'}
      </Text>
      <Spacer />
      {isEditMode && (
        <CloseButton
          data-testid='EditCheckPointHeader:close'
          ml={4}
          onClick={onClose}
        />
      )}
    </HStack>
  )
}
